import axios from "axios";
import { Loading, Message, MessageBox } from "ccui";
import store from "../store";
import { addUrlPerFix } from "@/basa/utils";
const baseURL = addUrlPerFix(process.env.VUE_APP_BASE_URL);
import Cookies from "js-cookie";
import { getArgs } from "@/basa/utils";
import Vue from "vue";
import { isShowErrorMessage } from "ccui/lib/utils/util";
import globalCofig from "@/setting/setting";
// 获取token
// if (sessionStorage.getItem("userInfo")) {
//   const userToke = JSON.parse(sessionStorage.getItem("userInfo")).userToken;
//   const sessionId = JSON.parse(sessionStorage.getItem("userInfo")).sessionId;
//   axios.defaults.headers.common["UserToken"] = userToke || "";
//   axios.defaults.headers.common["SessionId"] = sessionId || "";
// }
let CancelToken = axios.CancelToken; //取消请求

axios.defaults.withCredentials = true;

const service = axios.create({
  baseURL: baseURL, // api 的 base_url
  timeout: globalCofig.axiosTimeOut // request timeout
});

// request interceptor
let loadingObj;
let pageLoading = "";
let pendingFrontend = {}; // 现在在执行的方法 //防止前端重复点击重复添加
let pendingBackend = []; // 判断后端是否请求完成没有请求完成不允许继续点击
service.interceptors.request.use(
  config => {
    config.headers.Authorization = Cookies.get("access_token") || "";
    config.headers.APP_TOKEN = localStorage.appToken || "";
    // Do something before request is sent
    // 加loading
    if (typeof config.data === "object" && config.data.isShowLoading === true) {
      delete config.data.isShowLoading;
      store.commit(
        "SET_LOADINGMESSAGE",
        config.data.loadingMessage || "加载中,请稍等..."
      );
      delete config.data.loadingMessage;
      loadingObj = Loading.service({
        lock: true,
        text: store.getters.loadingMessage,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
    }
    if (
      typeof config.data === "object" &&
      config.data.isShowPageLoading === true
    ) {
      pageLoading = config.url;
      store.dispatch("setPageLoadingEnable", true);
      store.dispatch("setPageLoading", true);
      delete config.data.isShowPageLoading;
    }
    /**增加页面请求拦截Begin 防止重复点击**/
    if (typeof config.data === "object" && config.data.requestLimit === true) {
      let key = `${config.baseURL}${config.url}${JSON.stringify(config.data)}`;
      console.log("我进来了");
      if (key in pendingFrontend) {
        if (Date.now() - pendingFrontend[key] > globalCofig.requestDuration) {
          delete pendingFrontend[key];
          if (pendingBackend.includes(key)) {
            // 先判断前端请求
            // 再判断后端请求
            // 取消请求
            console.log("取消请求");
            config.cancelToken = new CancelToken(c => {
              c("repeated");
            });
          } else {
            pendingBackend.push(key);
          }
        } else {
          // 如果小于1s取消请求
          config.cancelToken = new CancelToken(c => {
            c("repeated");
          });
        }
      } else {
        pendingFrontend[key] = Date.now();
        if (pendingBackend.includes(key)) {
          console.log("取消请求");
          config.cancelToken = new CancelToken(c => {
            c("repeated");
          });
        } else {
          pendingBackend.push(key);
        }
      }
    }
    /**增加页面请求拦截End 防止重复点击**/
    // config.data.agentId = getArgs("a");
    if (config.url.indexOf("spcms") !== -1) {
      config.data.agentId = 100131;
    } else if (config.url.indexOf("bid-scp") !== -1) {
      config.data.agentId = 100121;
    } else {
      config.data.agentId = 100127;
    }
    config.data.languageType = Cookies.get("language") || "zh-cn";
    if (sessionStorage.getItem("userInfo")) {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // alert(userInfo)
      config.data.baseAppId = userInfo.appId;
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 关闭数据变动loading
    if (loadingObj !== undefined) {
      loadingObj.close();
      loadingObj = undefined;
    }
    let questData = JSON.parse(response.config.data);
    if (questData.requestLimit) {
      delete questData.agentId;
      delete questData.languageType;
      let key = `${response.config.baseURL}${
        response.config.url
      }${JSON.stringify(questData)}`;
      let index = pendingBackend.findIndex(n => n === key);
      if (index > -1) {
        pendingBackend.splice(index, 1);
      }
    }

    // 关闭页面列表loading
    if (
      store.state.app.pageLoading.pageLoadingStatus &&
      response.config.url === pageLoading
    ) {
      Vue.nextTick(() => {
        store.dispatch("setPageLoading", false);
      });
    }
    // 后端报错处理
    if (response.data.code !== "0") {
      if (typeof response.data === "string") {
        if (response.data.substring(0, 15) === "<!DOCTYPE html>") {
          window.location.href =
            addUrlPerFix(process.env.VUE_APP_LOGIN) +
            "?redirectUrl=" +
            encodeURIComponent(window.location.href);
        }
      } else {
        // 依据code码做错误处理
        return errorHandler(response);
      }
    } else {
      // 请求正常
      return response;
    }
  },
  error => {
    // 系统错误处理
    if (loadingObj) {
      loadingObj.close();
      loadingObj = undefined;
    }
    /***取消请求返回Begin***/
    if (error && error.message === "repeated") {
      // 重复请求被取消了的
      return Promise.reject(error);
    } else {
      // 其他错误全部重置
      pendingBackend = [];
    }
    /**取消请求返回End**/

    let message =
      error.code === "ECONNABORTED"
        ? `<i class="el-icon-warning"></i>网络请求超时`
        : `<i class="el-icon-warning"></i>系统错误，请<a class="ccui-message-box-custom-link">联系管理员</a>`;
    Message.closeAll();
    MessageBox.alert(message, "提示", {
      distinguishCancelAndClose: true,
      dangerouslyUseHTMLString: true,
      customClass: "ccui-message-box-custom"
    });

    return Promise.reject(error);
  }
); // 错误码处理
function errorHandler(response) {
  if (response.config.url === "/apis/scp/smc/users/signup/loginSup") {
    return Promise.reject(response);
  } else {
    switch (response.data.code) {
      case "111":
        window.location.href =
          addUrlPerFix(process.env.VUE_APP_LOGIN) +
          "?redirectUrl=" +
          encodeURIComponent(window.location.href);
        return;
      case "112":
        window.location.href =
          addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
          "?CLIENT_ID=" +
          getArgs("a") +
          "&CALLBACK_URL=" +
          encodeURIComponent(window.location.href);
        return;
      case "305":
      case "307":
        store.dispatch("setRouter305", {
          isShow: true,
          message: response.data.message
        });
        return response;
      case "309":
        return response;
      default:
        Message.closeAll();
        // 区分业务状态码处理和系统状态码处理
        if (isShowErrorMessage(response.data.code)) {
          // customErrorHandle为自定义错误码的处理,如需要自定义状态码处理,放开注释
          // customErrorHandle(response) &&
          Message({
            message: response.data.message,
            type: "error",
            duration: globalCofig.duration,
            showClose: true,
            ccuiCustom: true
          });
        } else {
          MessageBox.alert(
            `<i class="el-icon-warning"></i>系统错误（错误代码：${response.data.code}），请<a class="ccui-message-box-custom-link">联系管理员</a>`,
            "提示",
            {
              distinguishCancelAndClose: true,
              dangerouslyUseHTMLString: true,
              customClass: "ccui-message-box-custom"
            }
          );
        }
        return Promise.reject(response);
    }
  }
}
export default service;

// import axios from "axios";
// import { Loading, Message, MessageBox } from "ccui";
// import store from "../store";
// import { addUrlPerFix } from "../../basa/utils";
// const baseURL = addUrlPerFix(process.env.VUE_APP_BASE_URL);
// import Cookies from "js-cookie";
// import Vue from "vue";
// import { getArgs } from "@/basa/utils";
// import { isShowErrorMessage } from "ccui/lib/utils/util";
//
// axios.defaults.withCredentials = true;
//
// const service = axios.create({
//   baseURL: baseURL, // api 的 base_url
//   timeout: 10000 // request timeout
// });
//
// let loadingObj;
// let pageLoading = "";
//
// // 请求拦截器
// service.interceptors.request.use(
//     config => {
//       config.headers.Authorization = Cookies.get("access_token") || "";
//       config.headers.APP_TOKEN = localStorage.appToken || "";
//       // 加数据变动loading
//       if (typeof config.data === "object" && config.data.isShowLoading === true) {
//         delete config.data.isShowLoading;
//         store.commit(
//             "SET_LOADINGMESSAGE",
//             config.data.loadingMessage || "处理中,请稍等..."
//         );
//         delete config.data.loadingMessage;
//         loadingObj = Loading.service({
//           lock: true,
//           text: store.getters.loadingMessage,
//           spinner: "el-icon-loading",
//           background: "rgba(0, 0, 0, 0.2)",
//           customClass: "ccui-custom-loading"
//         });
//       }
//       // 加页面列表loading
//       if (
//           typeof config.data === "object" &&
//           config.data.isShowPageLoading === true
//       ) {
//         pageLoading = config.url;
//         store.dispatch("setPageLoadingEnable", true);
//         store.dispatch("setPageLoading", true);
//         delete config.data.isShowPageLoading;
//       }
//
//       // 获取agentId
//       config.data.agentId = getArgs("a");
//
//       if (store.state.user.userDetal) {
//         const userInfo = store.state.user.userDetal;
//         config.data.baseAppId = userInfo.appId;
//       }
//       return config;
//     },
//     error => {
//       // Do something with request error
//       Promise.reject(error);
//     }
// );
//
// // 响应拦截器
// service.interceptors.response.use(
//     response => {
//       // 关闭数据变动loading
//       if (loadingObj !== undefined) {
//         loadingObj.close();
//         loadingObj = undefined;
//       }
//       // 关闭页面列表loading
//       if (
//           store.state.app.pageLoading.pageLoadingStatus &&
//           response.config.url === pageLoading
//       ) {
//         Vue.nextTick(() => {
//           store.dispatch("setPageLoading", false);
//         });
//       }
//       // 后端报错处理
//       if (response.data.code !== "0") {
//         if (typeof response.data === "string") {
//           if (response.data.substring(0, 15) === "<!DOCTYPE html>") {
//             window.location.href =
//                 addUrlPerFix(process.env.VUE_APP_LOGIN) +
//                 "?redirectUrl=" +
//                 encodeURIComponent(window.location.href);
//           }
//         } else {
//           // 依据code码做错误处理
//           return handleError(response);
//         }
//       } else {
//         // 请求正常
//         return response;
//       }
//     },
//     error => {
//       // 系统错误处理
//       if (loadingObj) {
//         loadingObj.close();
//         loadingObj = undefined;
//       }
//       let message =
//           error.code === "ECONNABORTED"
//               ? `<i class="el-icon-warning"></i>网络请求超时`
//               : `<i class="el-icon-warning"></i>系统错误，请<a class="ccui-message-box-custom-link">联系管理员</a>`;
//       Message.closeAll();
//       MessageBox.alert(message, "提示", {
//         distinguishCancelAndClose: true,
//         dangerouslyUseHTMLString: true,
//         customClass: "ccui-message-box-custom"
//       });
//
//       return Promise.reject(error);
//     }
// );
//
// // 错误码处理
// function handleError(response) {
//   switch (response.data.code) {
//     case "111":
//       window.location.href =
//           addUrlPerFix(process.env.VUE_APP_LOGIN) +
//           "?redirectUrl=" +
//           encodeURIComponent(window.location.href);
//       return;
//     case "112":
//       window.location.href =
//           addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
//           "?CLIENT_ID=" +
//           getArgs("a") +
//           "&CALLBACK_URL=" +
//           encodeURIComponent(window.location.href);
//       return;
//     case "305":
//     case "307":
//       store.dispatch("setRouter305", {
//         isShow: true,
//         message: response.data.message
//       });
//       return response;
//     case "309":
//       return response;
//     default:
//       Message.closeAll();
//       // 区分业务状态码处理和系统状态码处理
//       if (isShowErrorMessage(response.data.code)) {
//         // customErrorHandle为自定义错误码的处理,如需要自定义状态码处理,放开注释
//         // handleCustomError(response) &&
//         Message({
//           message: response.data.message,
//           type: "error",
//           showClose: true,
//           ccuiCustom: true
//         });
//       } else {
//         MessageBox.alert(
//             `<i class="el-icon-warning"></i>系统错误（错误代码：${response.data.code}），请<a class="ccui-message-box-custom-link">联系管理员</a>`,
//             "提示",
//             {
//               distinguishCancelAndClose: true,
//               dangerouslyUseHTMLString: true,
//               customClass: "ccui-message-box-custom"
//             }
//         );
//       }
//       return Promise.reject(response);
//   }
// }
//
// /*
//  * 自定义错误码的处理
//  * 以下为示例
//  * 如果需要之后的Message执行,需方法里返回return true
//  * */
// // function handleCustomError(response) {
// //   let obj = {
// //     "10202": () => {
// //       MessageBox.alert(
// //         `<i class="el-icon-warning"></i>店铺已关闭</a>`,
// //         "提示",
// //         {
// //           distinguishCancelAndClose: true,
// //           dangerouslyUseHTMLString: true,
// //           customClass: "ccui-message-box-custom",
// //           callback: () => {
// //             window.location.href =
// //               addUrlPerFix(process.env.VUE_APP_BASE_URL) +
// //               "goods/goodsdistribution/alllist?a=" +
// //               window.getArgs("a");
// //           }
// //         }
// //       );
// //     },
// //     "10301": () => {
// //       MessageBox.alert(
// //         `<i class="el-icon-warning"></i>${response.data.message}</a>`,
// //         "提示",
// //         {
// //           distinguishCancelAndClose: true,
// //           dangerouslyUseHTMLString: true,
// //           customClass: "ccui-message-box-custom",
// //           callback: () => {
// //             window.location.href =
// //               addUrlPerFix(process.env.VUE_APP_BASE_URL) +
// //               "orders/enterprise-order?a=" +
// //               window.getArgs("a");
// //           }
// //         }
// //       );
// //     }
// //   };
// //
// //   return obj[response.data.code]();
// // }
//
// export default service;
